import React from "react";
import "./LoadingSpinner.scss";

interface Props {
  className?: string;
}

const LoadingSpinner: React.FC<Props> = (props) => (
  <div className={`loadingSpinner ${props.className || ""}`}>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);

export default LoadingSpinner;
